import { amber, blue, green, grey, purple, teal } from "@mui/material/colors";

// Shared chip tones + small formatting helpers for the Sizer tab. Kept in one
// place so the hero card (SizerCurrentCard) and the version-history table
// (LoanSizerUploadsTable) render the same colors and derive versions the same
// way.

export const SIZER_TYPE_TONE = {
  GUC: { fg: blue[800], bg: blue[50] },
  RTL: { fg: purple[800], bg: purple[50] },
  DSCR: { fg: teal[800], bg: teal[50] },
  Other: { fg: grey[800], bg: grey[100] },
};

export const STAGE_TONE = {
  "Intake Pricing": { fg: grey[700], bg: grey[100] },
  "Request Lock Pricing": { fg: amber[900], bg: amber[50] },
  "Update Lock Pricing": { fg: amber[900], bg: amber[50] },
  "Final Pricing for Closing": { fg: green[800], bg: green[50] },
};

export const LOAN_STATUS_TONE = {
  Prospect: { fg: grey[700], bg: grey[100] },
  Submitted: { fg: blue[800], bg: blue[50] },
  "In Underwriting": { fg: amber[900], bg: amber[50] },
  Approved: { fg: green[800], bg: green[50] },
  Closed: { fg: green[900], bg: green[100] },
  Declined: { fg: grey[800], bg: grey[200] },
};

export const typeTone = (t) => SIZER_TYPE_TONE[t] || SIZER_TYPE_TONE.Other;

// Sort trackers newest-first so index 0 is "current". Non-mutating.
export const sortByUploadDateDesc = (rows) =>
  [...(rows || [])].sort((a, b) => {
    const da = a?.uploadDate ? Date.parse(a.uploadDate) : 0;
    const db = b?.uploadDate ? Date.parse(b.uploadDate) : 0;
    return db - da;
  });

// Two-letter initials for the "by DE" upload attribution.
export const getInitials = (name) => {
  if (!name) return "";
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

// Rates are stored as decimal fractions (0.065 = 6.5%). Return the difference
// between two versions in percentage POINTS, with a direction, for the
// "▼ 0.125 vs. prior" caption. Returns null when either side is missing.
export const rateDelta = (curr, prior) => {
  if (typeof curr !== "number" || typeof prior !== "number") return null;
  const diff = (curr - prior) * 100;
  if (Math.abs(diff) < 0.0005) return { dir: "flat", value: 0 };
  return { dir: diff > 0 ? "up" : "down", value: Math.abs(diff) };
};

// Trim trailing zeros off a fixed-precision number: 0.125000 -> "0.125".
export const trimNum = (n, digits = 3) =>
  Number(n)
    .toFixed(digits)
    .replace(/\.?0+$/, "");
